import { ServiceTypeFormType } from 'components/service-types/ServiceTypeForm';

export const updateServiceTypeInitialValues: Partial<ServiceTypeFormType> = {};
